class CartDrawerFreeShipping extends HTMLElement {
    constructor() {
        super();
        this.title = this.dataset.title || 'Free Shipping';
        this.unlockedTitle = this.dataset.unlockedTitle || 'Free Shipping Unlocked!';
        this.cartTotal = parseInt(this.dataset.cartTotal) || 0;
        this.minFreeShipping = parseInt(this.dataset.minFreeShipping) || 0;
        this.percentageElement = this.querySelector('.free-shipping-bar--percentage');
        this.titleElement = this.querySelector('h5');

        this.init();
    }

    init() {
        this.updateProgress();
        this.setupObserver();
    }

    updateProgress() {
        if (this.minFreeShipping <= 0) {
            this.style.display = 'none';
            return;
        }

        const percentage = Math.min((this.cartTotal / this.minFreeShipping) * 100, 100);
        const isUnlocked = this.cartTotal >= this.minFreeShipping;

        // Update progress bar
        if (this.percentageElement) {
            this.percentageElement.style.width = `${percentage}%`;
            this.percentageElement.classList.toggle('unlocked', isUnlocked);
        }

        // Update title
        if (this.titleElement) {
            this.titleElement.textContent = isUnlocked ? this.unlockedTitle : this.title;
        }

        // Update container classes
        this.classList.toggle('unlocked', isUnlocked);
    }

    setupObserver() {
        // Listen for cart updates
        document.addEventListener('cart:updated', (event) => {
            if (event.detail && event.detail.cart) {
                this.cartTotal = event.detail.cart.total_price;
                this.updateProgress();
            }
        });

        // Listen for cart drawer open events
        document.addEventListener('cart-drawer:opened', () => {
            this.updateProgress();
        });
    }

    // Method to manually update cart total
    updateCartTotal(total) {
        this.cartTotal = total;
        this.updateProgress();
    }
}

customElements.define('cart-drawer-free-shipping', CartDrawerFreeShipping);
